import './ServicesPillars.css';

const DataFlowDiagram = () => (
  <svg
    viewBox="0 0 360 140"
    role="img"
    aria-label="Data strategy flow: ERP, CRM and Spreadsheets feed a governed data model that powers dashboards"
    preserveAspectRatio="xMidYMid meet"
  >
    <defs>
      <marker id="ds-arrow" markerWidth="8" markerHeight="8" refX="6" refY="3" orient="auto" markerUnits="userSpaceOnUse">
        <path d="M0,0 L6,3 L0,6 Z" fill="#FF8C00" />
      </marker>
    </defs>
    <g stroke="#FF8C00" strokeWidth="2" markerEnd="url(#ds-arrow)" fill="none">
      <line x1="94" y1="25" x2="138" y2="61" />
      <line x1="94" y1="70" x2="138" y2="70" />
      <line x1="94" y1="115" x2="138" y2="79" />
      <line x1="252" y1="70" x2="282" y2="70" />
    </g>
    <g fill="#003A70">
      <rect x="8" y="12" width="86" height="26" rx="5" />
      <rect x="8" y="57" width="86" height="26" rx="5" />
      <rect x="8" y="102" width="86" height="26" rx="5" />
      <rect x="142" y="48" width="110" height="44" rx="6" />
      <rect x="286" y="57" width="66" height="26" rx="5" />
    </g>
    <g fill="#ffffff" textAnchor="middle" fontWeight="600">
      <text x="51" y="29" fontSize="11">ERP</text>
      <text x="51" y="74" fontSize="11">CRM</text>
      <text x="51" y="119" fontSize="9.5">Spreadsheets</text>
      <text x="197" y="66" fontSize="10.5">Governed</text>
      <text x="197" y="80" fontSize="10.5">data model</text>
      <text x="319" y="74" fontSize="9.5">Dashboards</text>
    </g>
  </svg>
);

const ForecastChart = () => (
  <svg
    viewBox="0 0 320 150"
    role="img"
    aria-label="Advanced analytics forecast: a solid navy actuals line continuing as a dashed orange forecast line with a shaded confidence band"
    preserveAspectRatio="xMidYMid meet"
  >
    <g fontSize="10" fill="#334155" fontWeight="600">
      <line x1="14" y1="15" x2="34" y2="15" stroke="#003A70" strokeWidth="2.5" strokeLinecap="round" />
      <text x="39" y="18">Actual</text>
      <line x1="92" y1="15" x2="112" y2="15" stroke="#FF8C00" strokeWidth="2.5" strokeDasharray="5 4" strokeLinecap="round" />
      <text x="117" y="18">Forecast</text>
    </g>
    <line x1="14" y1="132" x2="306" y2="132" stroke="#E2E8F0" strokeWidth="1" />
    <path d="M188,84 L224,66 L260,54 L300,42 L300,76 L260,80 L224,84 L188,84 Z" fill="#FF8C00" fillOpacity="0.15" />
    <line x1="188" y1="30" x2="188" y2="132" stroke="#CBD5E1" strokeWidth="1" strokeDasharray="3 3" />
    <polyline points="16,116 46,106 76,112 106,92 136,98 166,80 188,84" fill="none" stroke="#003A70" strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round" />
    <polyline points="188,84 224,74 260,64 300,56" fill="none" stroke="#FF8C00" strokeWidth="2.5" strokeDasharray="5 4" strokeLinejoin="round" strokeLinecap="round" />
  </svg>
);

const PILLARS = [
  {
    slug: 'bi-dashboards',
    kind: 'image',
    media: '/kpi-exec-crop.webp',
    mediaAlt: 'KPI Executive Dashboard: customer satisfaction and first response time SLA KPIs with goals, status badges and trend sparklines',
    title: 'BI & Dashboards',
    text: 'Executive dashboards and automated reporting in Tableau and Power BI. One trusted, real-time view of performance, built for the people making the decisions.',
    short: 'BI & Dashboards',
    href: '/services/bi-dashboards',
  },
  {
    slug: 'data-strategy',
    kind: 'diagram',
    title: 'Data Strategy',
    text: 'Roadmaps, metric governance, and integration that turn disconnected systems into one reliable foundation you can build on.',
    short: 'Data Strategy',
    href: '/services/data-strategy',
  },
  {
    slug: 'advanced-analytics',
    kind: 'forecast',
    title: 'Advanced Analytics',
    text: 'Forecasting, segmentation, and predictive models that help you act on what\u2019s coming, not just report what already happened.',
    short: 'Advanced Analytics',
    cta: 'Advanced analytics services',
    href: '/services/advanced-analytics',
  },
];

export const ServicesPillars = () => (
  <section className="section services" id="services">
    <div className="container">
      <div className="heading">
        <h2>Three ways we turn data into decisions.</h2>
        <p>We build your dashboards, plan your data, and predict what&rsquo;s coming next. Done deeply, not spread thin.</p>
      </div>

      <div className="cards pillars">
        {PILLARS.map((p) => (
          <article className="service" key={p.slug} data-testid={`service-pillar-${p.slug}`}>
            <div className="service-media" data-testid={`service-pillar-media-${p.slug}`}>
              {p.kind === 'image' ? (
                <img src={p.media} alt={p.mediaAlt} loading="lazy" decoding="async" />
              ) : p.kind === 'diagram' ? (
                <DataFlowDiagram />
              ) : (
                <ForecastChart />
              )}
            </div>
            <h3>{p.title}</h3>
            <p>{p.text}</p>
            <a className="text-link" href={p.href} data-testid={`service-pillar-link-${p.slug}`}>
              {p.cta ? p.cta : `Explore ${p.short}`} &rarr;
            </a>
          </article>
        ))}
      </div>
    </div>
  </section>
);
